var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "circles_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 162
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v142c0 11.046-2.042 20-4.56 20H0V0z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#fff",
    mask: "url(#circles_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.5 107c27.338 0 49.5-22.162 49.5-49.5S107.838 8 80.5 8 31 30.162 31 57.5 53.162 107 80.5 107z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M54 191c29.823 0 54-24.177 54-54S83.823 83 54 83 0 107.177 0 137s24.177 54 54 54z"
  }))));
}
export default SvgCircles;